module.exports = __webpack_public_path__ + "img/earthdev.ccc20b00.png";